import { LitElement, css, html } from 'lit';
import { customElement, property, query } from 'lit/decorators';

import { TextField } from '@material/mwc-textfield';
import { makeColorIntoDataSvg } from '../helpers/colors';

@customElement('color-picker')
export class ColorPicker extends LitElement {
    @query('#color')
    private colorElement!: TextField;

    @query('#colorImage')
    private readonly colorImageElement!: HTMLImageElement;

    @query('#colorPicker')
    private colorPickerElement!: HTMLInputElement;

    @property({ type: Boolean })
    open: boolean = false;

    @property({ type: String })
    size?: string;

    @property({ type: String })
    value: string = '';

    @property({ type: String })
    label: string = '';

    @property({ type: String })
    helper: string = '';

    @property({ type: Boolean })
    required: boolean = false;

    @property({ type: Boolean })
    disabled: boolean = false;

    async updated(changedProperties: any) {
        // Listen for 'icon' changes so we can change data SVGs into colors.
        changedProperties.forEach((oldValue: any, propName: any) => {
            if (propName === 'icon') {
                // Nothing.
            }
        });
        await this.updateLayout();
    }


	async updateLayout() {
        if (this.open) {
            await this.colorElement?.layout();
        }
	}

    reportValidity() {
        return this.colorElement.reportValidity();
    }

    getIcon(maybeIcon?: string) {
        return makeColorIntoDataSvg(this.value);
    }

    private openColorPicker() {
        this.colorPickerElement.focus();
        this.colorPickerElement.value = this.value;
        this.colorPickerElement.click();
    }

    private changedSelf() {
        this.value = this.colorElement.value;
        this.dispatchEvent(new CustomEvent('change', { detail: { value: this.value } }));
    }

    render() {
        return html`
            <div class="container">
                <proxi-textfield
                    outlined
                    id="color"
                    class="${this.size === 'small' ? 'input-small' : 'input'}"
                    helper="${this.helper}"
                    label="${this.label}"
                    value="${this.value}"
                    @change="${this.changedSelf}"
                    charcounter
                    ?required="${this.required}"
                    ?disabled="${this.disabled}"
                ></proxi-textfield>
                <img
                    id="colorImage"
                    class="image"
                    @click=${this.openColorPicker}
                    src="${this.getIcon(this.value)}"
                    width="24"
                    height="24"
                />
                <mwc-icon-button
                    class="pickerImage"
                    icon="colorize"
                    @click="${this.openColorPicker}"
                    ?disabled="${this.disabled}"
                ></mwc-icon-button>
                <input
                    id="colorPicker"
                    ?disabled="${this.disabled}"
                    type="color"
                    @change="${(e: any) => {
                        this.colorElement.value = e.target.value;
                        this.changedSelf();
                    }}"
                />
            </div>
        `;
    }

    static get styles() {
        return css`
            .container {
                display: flex;
                flex-direction: row;
                position: relative;
            }

            .input-small {
                --mdc-text-field-outlined-idle-border-color: lightgray;
                --mdc-text-field-ink-color: var(--main-primary-color);
            }

            .image {
                position: absolute;
                top: 0.5rem;
                right: 20px;
                z-index: 1;
            }

            .pickerImage {
                --mdc-icon-button-size: 1rem;
                position: absolute;
                z-index: 2;
                top: 0.75rem;
                right: 12px;
            }

            #colorPicker {
                opacity: 0;
                width: 0px;
                margin: 0px;
                padding: 0px;
            }

            .input {
                width: 100%;
            }
        `;
    }
}
